export function BrandMark({ className, testId }) {
  return (
    <img data-testid={testId} src={`${process.env.PUBLIC_URL}/clippedup-mark.svg?v=2`}
      width="32" height="32" alt="" aria-hidden="true" draggable="false"
      className={className} />
  );
}
